import Grid from "@mui/material/Grid";
import { terItem } from "../../css/dinamic/territories";
import TerData from "./TerData";
import ButtonsList from "./ButtonsList";
import ItemHeader from "./ItemHeader";
import CalenderHistory from "./CalenderHistory";
import { GridItem } from "../../components/GridItem";

export default function TerritoriesList({
  list,
  askOpenTerritory,
  terGroups,
  openRecords,
  editTer,
  askDelete,
  setSelectedTer,
  setOpen,
}) {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      <div
        style={{
          overflow: "auto",
          paddingBottom: 20,
        }}
      >
        <Grid
          container
          spacing={5}
          padding={2}
          columns={{ xs: 1, sm: 8, md: 21, lg: 20 }}
        >
          {list.map((o, index) => (
            <Grid key={index} item xs={1} sm={4} md={7} lg={4}>
              <GridItem style={terItem(o.HECHOS, o.TOTAL)}>
                <ItemHeader
                  id={o.ID}
                  name={o.NOM}
                  descrip={o.DESCRIP}
                  onClick={askOpenTerritory}
                  setSelectedTer={setSelectedTer}
                  setOpen={setOpen}
                />
                <TerData
                  data={o}
                  list={o.ID === "" ? list.length - 1 : null}
                  terGroups={terGroups}
                  onClick={askOpenTerritory}
                />
                <ButtonsList
                  data={o}
                  openRecords={openRecords}
                  editTer={editTer}
                  askDelete={askDelete}
                />
                <div style={{ position: "relative", height: 40 }} />
                <CalenderHistory data={o} openRecords={openRecords} />
              </GridItem>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}
